var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import React, { Component } from 'react';
import { default as styled } from 'styled-components';
import { withSuomifiDefaultProps } from '../theme/utils';
import { Heading as CompHeading, } from '../../components/Heading/Heading';
import { baseStyles } from './Heading.baseStyles';
import classnames from 'classnames';
import { logger } from '../../utils/logger';
var baseClassName = 'fi-heading';
var smallScreenClassName = baseClassName + "--small-screen";
var StyledHeading = styled(function (_a) {
    var tokens = _a.tokens, color = _a.color, smallScreen = _a.smallScreen, className = _a.className, variant = _a.variant, asProp = _a.asProp, passProps = __rest(_a, ["tokens", "color", "smallScreen", "className", "variant", "asProp"]);
    var _b;
    return (React.createElement(CompHeading, __assign({}, passProps, { className: classnames(className, [baseClassName + "--" + variant], (_b = {},
            _b[smallScreenClassName] = smallScreen,
            _b)), variant: variant === 'h1hero' ? 'h1' : variant, as: asProp })));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), function (props) { return baseStyles(props); });
var Heading = (function (_super) {
    __extends(Heading, _super);
    function Heading() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Heading.prototype.render = function () {
        var _a = withSuomifiDefaultProps(this.props), variant = _a.variant, passProps = __rest(_a, ["variant"]);
        if (!variant) {
            logger.warn("Does not contain heading level (variant): " + passProps.children);
            return null;
        }
        return React.createElement(StyledHeading, __assign({}, passProps, { variant: variant }));
    };
    Heading.h1hero = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h1hero" }))); };
    Heading.h1 = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h1" }))); };
    Heading.h2 = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h2" }))); };
    Heading.h3 = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h3" }))); };
    Heading.h4 = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h4" }))); };
    Heading.h5 = function (props) { return (React.createElement(StyledHeading, __assign({}, withSuomifiDefaultProps(props), { variant: "h5" }))); };
    return Heading;
}(Component));
export { Heading };
var templateObject_1;
//# sourceMappingURL=Heading.js.map